<template>
  <div class="flex items-center space-x-2">
    <o-chip v-if="isRequestStateRequested" flat variant="warning" size="sm">
      {{ $t('form.requested') }}
    </o-chip>
    <o-chip v-if="isRequestStateCompleted" flat variant="success" size="sm">
      {{ $t('form.completed') }}
    </o-chip>
    <o-chip v-if="isFormStateLocked" flat variant="danger" size="sm">
      {{ $t('general.locked') }}
    </o-chip>
    <o-chip v-if="isFormStateReopened" flat variant="danger">
      {{ $t('form.reopened') }}
    </o-chip>
    <o-chip v-if="isRequestStateUpdateRequested" flat variant="warning" size="sm">
      {{ $t('form.updateRequested') }}
    </o-chip>
    <o-chip v-if="isRequestStateScheduled" flat size="sm" :variant="isAutomationEnabled ? 'warning' : null">
      {{ $t('general.colonSeparator', { label1: $t('general.scheduled'), label2: scheduledLabel }) }}
    </o-chip>
    <o-chip v-if="customerForm.consentAccepted" flat variant="success" size="sm">
      {{ $t('form.consentAccepted') }}
    </o-chip>
    <o-chip v-if="includeReservation && reservation" flat variant="info" size="sm">
      {{ reservation.customerInfoLabel || reservation.infoLabel || $t('general.appointment') }}
    </o-chip>

    <!--<o-tooltip v-if="hasReservation" interactive>
      <o-chip flat variant="info" size="sm">
        Reservation
      </o-chip>

      <template v-slot:content>
        <o-panel-link :path="`/appointment/${reservation.idReservation}?date=${reservation.date}`" class="text-white text-sm hover:text-blue-400">
          <span class="font-medium">Reservation: </span>{{ reservation.customerInfoLabel || 'no info label included...' }}
        </o-panel-link>
      </template>
    </o-tooltip>-->
  </div>
</template>

<script setup lang="ts">
import { useI18n } from 'vue-i18n'

interface Props {
  customerForm: Record<string, any>
  includeReservation?: boolean
}

const props = withDefaults(defineProps<Props>(), {
  includeReservation: true,
})

const { t } = useI18n()
const { $date } = useNuxtApp()

const reservation = computed(() => {
  const customerForm = props.customerForm
  return customerForm.reservation || customerForm.reservationCustomer?.reservation
})

const scheduledLabel = computed(() => {
  if (props.customerForm.form.automationEnabled) {
    const date = new Date(props.customerForm.scheduledTime * 1000)
    const utc = ($date as any).utc(date)
    const format = ($date as any).presets.full
    const label = ($date as any).format(utc, format)

    return label
  } else {
    return t('general.disabled')
  }
})

const isRequestStateRequested = computed(() => props.customerForm.isRequestStateRequested)
const isRequestStateCompleted = computed(() => props.customerForm.isRequestStateCompleted)
const isRequestStateUpdateRequested = computed(() => props.customerForm.isRequestStateUpdateRequested)
const isRequestStateScheduled = computed(() => props.customerForm.isRequestStateScheduled)
const isFormStateLocked = computed(() => props.customerForm.isFormStateLocked)
const isFormStateReopened = computed(() => props.customerForm.isFormStateReopened)
const isAutomationEnabled = computed(() => props.customerForm.form?.automationEnabled)
const hasReservation = computed(() => !!reservation.value)
</script>
